import React, { useState } from 'react'
import styled from 'styled-components'
import replayIcon from '../images/icons/replay.png'
import block from '../images/icons/replay-NA.png'
import { FONTS, SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper';
import FacultyMemberModal from './GlobalModals/FacultyMemberModal'

const StyledAgenda = styled.div`
  font-family: ${FONTS.secondary};
  .agenda-item {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    margin-bottom: 8px;
    .end {
      color: #d08201;
    }
    .attend, .replay {
      border: none;
      background: transparent;
      height: 40px;
      width: 52px;
      margin: 0;
      padding: 0;
      p.load {
        margin: 0;
        font-weight: 500;
        color: red;
        font-size: 8px;
      }
      img {
        height: 100%;
        filter: invert(1);
      }
      img.pending, svg.pending {
        transform: scale(0.9);
      }
      .icon-label {
        color: #000;
        text-align: center;
        font-size: 6.5px;
        opacity: 1;
      }
      .checked {
        margin-top: 0px ;
      }
      &:hover {
        img.pending, svg.pending {
          transform: scale(1);
        }
        .icon-label {
          font-size: 1px;
          opacity: 0;
        }
      }
    }
  }
  .modal-styling {
    .time-container {
      width: 25%;
      font-weight: 500;
      display: flex;
      justify-content: space-evenly;
    }
    .desc-container {
      width: 75%;
      padding: 0 16px;
      padding-left: 24px;
    }
  }
  
  .time-container {
    width: 20%;
  }
  .desc-container {
    display: block;
    width: ${(props) => props.showReplay == true ? "60%" : "80%"};
  }
  .toggle {
    cursor: pointer;
    font-weight: 500;
  }
  .buttons-container {
    width: 20%;
    display: ${(props) => props.showReplay == true ? "flex" : "none"};
    justify-content: flex-end;
    align-items: center;
  }
  ${SIZES.mobile} {
    .time-container {
      font-size: 14px;
    }
    .desc-container {
      width: 60%;
    }
    .modal-styling {
      .time-container {
        width: 30%;
        justify-content: space-between;
      }
      .desc-container {
        width: 70%;
      }
    }
  }
`

export default function ProgrammeItem({ handlePlayback, item, inHall, replay=false }) {
  const [showSpeaker, setShowSpeaker] = useState(false);

  const handleOpenModal = (id) => {
    Amplitude.clickFacultyModal(id)
    setShowSpeaker(true)
  }

  const replayVideo = (session) => {
    handlePlayback(session)
  }

  return (
    <StyledAgenda showReplay={replay}>
      <div className={`agenda-item ${inHall ? '' : 'modal-styling'}`}>
        <div className="time-container">
          <small className="d-block start">{item.hide_time ? "" : item.start}</small>
          <small className="d-block end">{item.hide_time ? "" : item.end}</small>
        </div>
        <small className="desc-container" dangerouslySetInnerHTML={{ __html: item.title }}/>

       
        <div className="buttons-container">
          {/* REPLAY BUTTON */}
          {
            (item.redirect_url || item.vimeo_id) &&
            <button className="replay" onClick={() => replayVideo(item)}>
              <img
                src={(item.redirect_url || item.vimeo_id) ? replayIcon : block}
                className={(item.redirect_url || item.vimeo_id) ? `pending` : `checked`}
                alt="replay-button"
                style={{height:'70%'}}
              />
              <small className={`icon-label ${(item.redirect_url || item.vimeo_id) ? `d-block` : `d-none`}`}>
                Replay
              </small>
            </button>
          }
        </div>
      </div>
    </StyledAgenda>
  )
}
